<template>
  <div :id="qrKey" ref="qrCodeDiv" :style="{width: width + 'px', height: height + 'px'}" />
</template>

<script>
import QRCode from 'qrcodejs2'

export default {
  name: 'DYQrCode',
  props: {
    value: {
      type: String
    },
    width: {
      type: Number,
      default: 100
    },
    height: {
      type: Number,
      default: 100
    }
  },
  data() {
    return {
      qrKey: Math.ceil(Math.random() * 1000000)
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        if (val) {
          this.$nextTick(() => {
            this.createQrCode(val)
          })
        }
      }
    }
  },
  methods: {
    createQrCode(url) {
      const qrCode = document.getElementById(this.qrKey)
      if (!qrCode) return
      // 判读是否有子元素 ----删除全部子元素
      while (qrCode.firstChild) {
        // 删除第一个子元素
        qrCode.removeChild(qrCode.firstChild)
      }
      new QRCode(qrCode, {
        text: url,
        width: this.width,
        height: this.height,
        colorDark: '#333333', // 二维码颜色
        colorLight: '#ffffff', // 二维码背景色
        correctLevel: QRCode.CorrectLevel.L// 容错率，L/M/H
      })
      if (qrCode.children[1]) {
        qrCode.children[1].style = 'margin: 0 auto;'
      }
    }
  }
}
</script>

<style scoped>

</style>
